import {Component, Input, OnInit} from '@angular/core';
import {ImageApiService} from "../../../core/services/image-api.service";
import {NzModalRef} from "ng-zorro-antd/modal";

@Component({
  selector: 'app-add-image-model',
  templateUrl: './add-image-model.component.html',
  styleUrls: ['./add-image-model.component.scss']
})
export class AddImageModelComponent implements OnInit {
  @Input() imageName: any;
  // @Input() images: any;
  name = '';
  pexelsImage: any;
  selectedImage = '';
  isData = false;

  constructor(private imageApiService: ImageApiService, private modal: NzModalRef) {
  }

  ngOnInit(): void {
    this.isData = false;
    this.imageApiService.getPexelsImages(this.imageName).then(res => {
      this.pexelsImage = res;
      this.name = this.imageName;
      this.isData = true;
      this.selectedImage = this.pexelsImage?.photos[0]?.src?.large;
    });


  }

  async getPexelsImageAPI(text: any): Promise<any> {
    this.isData = false;
    try {
      this.pexelsImage = await this.imageApiService.getPexelsImages(text);
      this.isData = true;
    } catch (e) {

    }
  }

  getSelectedImage(): string {
    return this.selectedImage;
  }

  submit(): any {
    this.modal.close(this.selectedImage);
  }
}
